<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName"
                               labelValue="id" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
<!--              <el-form-item label="总收益">-->
<!--                  <el-input  v-model="queryForm.totalIncome"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="第三市场业绩">-->
<!--                  <el-input  v-model="queryForm.thirdPerformance"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="本月第三市场业绩">-->
<!--                  <el-input  v-model="queryForm.thirdPerformanceMonth"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="是否结束帮扶">
<!--                  <el-input  v-model="queryForm.isFinishHelp"></el-input>-->
                  <el-select
                      placeholder='是否结束帮扶'
                      clearable
                      style='width: 177px'
                      size='small'
                      v-model='queryForm.status'
                  >
                      <el-option
                          :label='"是"'
                          :value='1'
                      >
                      </el-option>
                      <el-option
                          :label='"否"'
                          :value='0'
                      >
                      </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getModelPlace9RecordList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addModelPlace9Record"-->
<!--        >新建</el-button>-->
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editModelPlace9Record(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteModelPlace9Record(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportModelPlace9RecordList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshModelPlace9RecordList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="modelPlace9RecordList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope" v-if='scope.row.user'>
              <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
              <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
              <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
          </template>
          <template slot-scope="scope" v-else>
              <div>暂无关联用户</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="totalIncome"
        label="总收益"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="thirdPerformance"
        label="第三市场业绩"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="thirdPerformanceMonth"
        label="本月第三市场业绩"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isFinishHelp"
        label="是否结束帮扶"
        width="180"
      >
          <template slot-scope="scope">
              {{scope.row.isFinishHelp==1?'是':'否'}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkModelPlace9Record(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editModelPlace9Record(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteModelPlace9Record(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="modelPlace9RecordStates[modelPlace9RecordState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="modelPlace9Record"
          ref="modelPlace9RecordForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="modelPlace9Record.userId"-->
<!--              :disabled="modelPlace9RecordState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" labelName="userName" :disabled="modelPlace9RecordState == 'check'"
                           labelValue="id" :value="modelPlace9Record.userId" :limit='1' size='small' placeholder='请选择用户'
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="总收益"
            prop="totalIncome"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="modelPlace9Record.totalIncome"
              :disabled="modelPlace9RecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="第三市场业绩"
            prop="thirdPerformance"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="modelPlace9Record.thirdPerformance"
              :disabled="modelPlace9RecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="本月第三市场业绩"
            prop="thirdPerformanceMonth"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="modelPlace9Record.thirdPerformanceMonth"
              :disabled="modelPlace9RecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否结束帮扶"
            prop="isFinishHelp"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="modelPlace9Record.isFinishHelp"-->
<!--              :disabled="modelPlace9RecordState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  placeholder='是否结束帮扶'
                  clearable
                  style='width: 177px'
                  size='small'
                  :disabled="modelPlace9RecordState == 'check'"
                  v-model='modelPlace9Record.status'
              >
                  <el-option
                      :label='"是"'
                      :value='1'
                  >
                  </el-option>
                  <el-option
                      :label='"否"'
                      :value='0'
                  >
                  </el-option>
              </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="modelPlace9RecordState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetModelPlace9RecordList();
                    this.getModelPlace9RecordList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetModelPlace9RecordList();
                    this.getModelPlace9RecordList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userId: '', //用户ID
                     totalIncome: '', //总收益
                     thirdPerformance: '', //第三市场业绩
                     thirdPerformanceMonth: '', //本月第三市场业绩
                     isFinishHelp: '', //是否结束帮扶
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                modelPlace9RecordState: 'add',
                modelPlace9RecordStates: {
                    add: '新建模式9记录',
                    check: '查看模式9记录',
                    edit: '修改模式9记录'
                },

                multipleSelection: [],
                modelPlace9RecordList: [],
                modelPlace9Record: {
                    id: '', //ID
                    userId: '', //用户ID
                    totalIncome: '', //总收益
                    thirdPerformance: '', //第三市场业绩
                    thirdPerformanceMonth: '', //本月第三市场业绩
                    isFinishHelp: '', //是否结束帮扶
                },
                btnLoading: false,

                rules: {
                    userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                    totalIncome: [{ required: true, message: '总收益不能为空', trigger: 'blur' }],
                    thirdPerformance: [{ required: true, message: '第三市场业绩不能为空', trigger: 'blur' }],
                    thirdPerformanceMonth: [{ required: true, message: '本月第三市场业绩不能为空', trigger: 'blur' }],
                    isFinishHelp: [{ required: true, message: '是否结束帮扶不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getModelPlace9RecordList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetModelPlace9RecordList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.modelPlace9RecordList = [];
            },
            resetDialog() {
                this.modelPlace9RecordState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户ID
                      totalIncome: '', //总收益
                      thirdPerformance: '', //第三市场业绩
                      thirdPerformanceMonth: '', //本月第三市场业绩
                      isFinishHelp: '', //是否结束帮扶
                };
                this.getModelPlace9RecordList();
            },
            getValueUser(value) {
                this.modelPlace9Record.userId = value
            },
            getSearchUser(value){
                this.queryForm.userId = value;
            },
            closeDialog() {
                this.showDialog = false
                this.modelPlace9Record = {
                      id: '', //ID
                      userId: '', //用户ID
                      totalIncome: '', //总收益
                      thirdPerformance: '', //第三市场业绩
                      thirdPerformanceMonth: '', //本月第三市场业绩
                      isFinishHelp: '', //是否结束帮扶
                };
            },
            submitForm() {
                if (this.modelPlace9RecordState == 'add') {
                    this.$refs.modelPlace9RecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/place9record/add`,{ ...this.modelPlace9Record }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetModelPlace9RecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.modelPlace9RecordState == 'edit') {
                    this.$refs.modelPlace9RecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.modelPlace9Record.user;
                            post(`/model/place9record/edit`,{ ...this.modelPlace9Record }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetModelPlace9RecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addModelPlace9Record() {
                this.showDialog = true;
                this.modelPlace9RecordState = 'add';
            },
            checkModelPlace9Record(modelPlace9RecordId) {
                console.log(modelPlace9RecordId);
                this.currentModelPlace9RecordId = modelPlace9RecordId;

                this.getModelPlace9RecordById();
                this.showDialog = true;
                this.modelPlace9RecordState = 'check';
            },
            editModelPlace9Record(modelPlace9RecordId) {
                console.log('modelPlace9Record', modelPlace9RecordId);
                if (modelPlace9RecordId) {
                    this.currentModelPlace9RecordId = modelPlace9RecordId;
                    this.getModelPlace9RecordById();
                } else {
                    this.modelPlace9Record = { ...this.modelPlace9Record, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.modelPlace9RecordState = 'edit';
            },
            deleteModelPlace9Record(modelPlace9RecordId) {
                let ids = '';
                if (modelPlace9RecordId) {
                    ids = modelPlace9RecordId;
                } else {
                    ids = this.multipleSelection.map((modelPlace9Record) => modelPlace9Record.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/model/place9record/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetModelPlace9RecordList();
                                this.getModelPlace9RecordList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshModelPlace9RecordList() {
                this.resetModelPlace9RecordList();
                this.getModelPlace9RecordList();
            },
            getModelPlace9RecordList(query = {}) {
                this.loading = true;
                get(`/model/place9record/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.modelPlace9RecordList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getModelPlace9RecordById() {
                get(`/model/place9record/get`,{ id: this.currentModelPlace9RecordId }).then((res) =>{
                    if(res.success){
                      this.modelPlace9Record = { ...this.modelPlace9Record, ...res.modelPlace9Record };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportModelPlace9RecordList() {
                //this.btnLoading = true;
                exprotExcel(`/model/place9record/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/model/place9record/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/model/place9record/importData`,formData);
              this.refreshModelPlace9RecordList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getModelPlace9RecordList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getModelPlace9RecordList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>